import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import PageShell from "../components/PageShell";
import { About } from "../components/Content1";
import { Section, Reveal } from "../lib/ui";

export default function OurStoryPage() {
  const navigate = useNavigate();
  return (
    <PageShell>
      <section className="px-6 md:px-10 lg:px-16 pt-36 pb-2 md:pt-40">
        <div className="max-w-7xl mx-auto">
          <button onClick={() => navigate("/about")} className="inline-flex items-center gap-2 text-silver/60 hover:text-gold transition-colors text-sm font-body" data-testid="story-back">
            <ArrowLeft size={16} className="rtl-flip" /> Back to about
          </button>
        </div>
      </section>

      <About />

      <Section className="bg-ink-surface">
        <div className="max-w-3xl">
          <Reveal>
            <div className="overline text-gold mb-5">Why It Matters To Us</div>
          </Reveal>
          <Reveal delay={0.05}>
            <p className="font-display font-light text-2xl md:text-3xl text-white leading-snug tracking-tight">
              "We've stood in the rooms where these decisions are made. That's the perspective we bring to
              every piece of advice we give."
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-silver/70 font-body font-light leading-relaxed">
              Between us we've spent decades in demanding environments — protecting people, planning for the
              worst, and learning what actually works when the pressure is on. We started Arco Orbis2 to put
              that hard-won experience to work for the people and organisations who need it, in language that
              makes sense and with advice you can act on.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-5 text-silver/70 font-body font-light leading-relaxed">
              We keep things personal on purpose. You'll always be dealing with the two of us — not a rotating
              cast of names you'll never remember. If you'd like to put a face to that, come and meet us.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <button onClick={() => navigate("/meet-us")} className="gold-sweep inline-flex items-center justify-center gap-2 rounded-full bg-gold text-black px-7 py-3.5 text-sm font-body font-medium hover:bg-gold-light transition-colors" data-testid="story-cta-meet">
                Meet Us <ArrowUpRight size={17} />
              </button>
              <button onClick={() => navigate("/services")} className="inline-flex items-center justify-center gap-2 rounded-full border border-silver/40 px-7 py-3.5 text-sm font-body text-silver hover:border-silver hover:text-white transition-colors" data-testid="story-cta-services">
                See What We Do
              </button>
            </div>
          </Reveal>
        </div>
      </Section>
    </PageShell>
  );
}
